(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('xellenz-cart-recommendations')) {
    customElements.define(
      'xellenz-cart-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loadingState) {
            return;
          }

          this.abortController = new AbortController();

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  this.observer.disconnect();
                  this.loadRecommendations();
                }
              },
              { rootMargin: '160px' }
            );

            this.observer.observe(this);
          } else {
            this.loadRecommendations();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.abortController?.abort();
        }

        async loadRecommendations() {
          if (this.dataset.loadingState) {
            return;
          }

          this.dataset.loadingState = 'loading';
          const urls = [this.dataset.complementaryUrl, this.dataset.relatedUrl].filter(Boolean);

          try {
            for (const url of urls) {
              const response = await fetch(url, {
                credentials: 'same-origin',
                signal: this.abortController.signal,
                headers: { Accept: 'text/html' }
              });

              if (!response.ok) {
                continue;
              }

              const html = await response.text();
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const recommendations = documentFragment.querySelector('[data-cart-drawer-recommendations-content]');

              if (recommendations?.querySelector('.horizontal-product')) {
                this.replaceChildren(recommendations);
                this.dataset.loadingState = 'loaded';
                return;
              }
            }

            this.dataset.loadingState = 'fallback';
          } catch (error) {
            if (error.name !== 'AbortError') {
              this.dataset.loadingState = 'fallback';
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
